import { hasAccessToBusinessUnit
// @ts-expect-error not migrated to TS yet
} from 'EmailData/selectors/user';
import { getUsageTracker } from 'EmailComponents/utils/tracking';
import { getCanViewApprovals } from 'EmailData/selectors/approvals';
import I18n from 'I18n';
import { Metrics } from 'email-management-lib/Shared/utils/metrics';
import { searchCrm } from 'email-management-lib/Shared/apis/crmSearch';
import useEmailUIModeProps from 'email-management-lib/refactor/components/manage/frameworkTable/hooks/useEmailUIModeProps';
import useEmailViewProps, { isDefaultViewUrl } from 'email-management-lib/refactor/components/manage/frameworkTable/hooks/useEmailViewProps';
import useInitialFilters from 'email-management-lib/refactor/components/manage/frameworkTable/hooks/useInitialFilters';
import { OVERRIDE_PROPERTY_CONTEXT, PROPERTIES_TO_SHOW_IN_COLUMNS_AND_FILTERS, PROPERTIES_TO_SHOW_ONLY_IN_COLUMNS } from 'email-management-lib/refactor/components/manage/frameworkTable/overrideProperties';
import { APPLICATION_ID, CRM_SEARCH_HIDDEN_AB_TEST_STATUS, CRM_SEARCH_HIDDEN_STATE, CRM_SEARCH_HIDDEN_SUBCATEGORY, MARKETING_EMAIL_OBJECT_TYPE, PROPERTIES, PROPERTIES_TO_HIDE, STATS_PROPERTIES_TO_SHOW } from 'email-management-lib/Shared/constants/frameworkTable';
import getShouldHidePublishStatusFilter from 'email-management-lib/refactor/utils/getShouldHidePublishStatusFilter';
import { FrameworkListingLibProvider } from 'framework-listing-lib';
import { NOT_IN } from 'framework-listing-lib/utils/filters';
import { parse } from 'hub-http/helpers/params';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { useHasBusinessUnitsRebrand } from 'ui-business-units-lib/hooks/useHasBusinessUnitsRebrand';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FrameworkTableProvider({
  children,
  onQueryChange
}) {
  const {
    state
  } = useParams();
  const shouldHidePublishStatusFilter = useMemo(() => {
    return getShouldHidePublishStatusFilter(state);
  }, [state]);
  const canAccessBusinessUnit = useSelector(hasAccessToBusinessUnit);
  const canViewApprovals = useSelector(getCanViewApprovals);
  const hiddenFilter = useMemo(() => ({
    filterGroups: [{
      filters: [NOT_IN(PROPERTIES.STATE, CRM_SEARCH_HIDDEN_STATE), NOT_IN(PROPERTIES.SUBCATEGORY, CRM_SEARCH_HIDDEN_SUBCATEGORY), NOT_IN(PROPERTIES.AB_TEST_STATUS, CRM_SEARCH_HIDDEN_AB_TEST_STATUS)]
    }]
  }), []);
  const {
    search
  } = useLocation();
  const queryStringObj = parse(search.substring(1));
  const shouldAddArchivedFalseFilter = useMemo(() => {
    if (state && isDefaultViewUrl(state)) {
      return false;
    }
    return true;
  }, [state]);
  const initialFilter = useInitialFilters({
    queryStringObj,
    shouldAddArchivedFalseFilter
  });
  const trackerProps = useMemo(() => ({
    applicationId: APPLICATION_ID,
    tracker: getUsageTracker()
  }), []);
  const searchInputProps = useMemo(() => ({
    hasSearchInput: true,
    onQueryChange,
    width: 400,
    placeholder: I18n.text('email-management.frameworkTable.search')
  }), [onQueryChange]);
  const hasBusinessUnitsRebrand = useHasBusinessUnitsRebrand();
  const propertyOverride = useMemo(() => {
    return Object.assign({}, OVERRIDE_PROPERTY_CONTEXT({
      canAccessBusinessUnit,
      hasBusinessUnitsRebrand
    }), STATS_PROPERTIES_TO_SHOW, PROPERTIES_TO_SHOW_ONLY_IN_COLUMNS(), PROPERTIES_TO_SHOW_IN_COLUMNS_AND_FILTERS({
      canViewApprovals
    }), PROPERTIES_TO_HIDE, {
      [PROPERTIES.PUBLISH_STATUS]: {
        hidden: shouldHidePublishStatusFilter
      }
    });
  }, [canAccessBusinessUnit, canViewApprovals, hasBusinessUnitsRebrand, shouldHidePublishStatusFilter]);
  const viewProps = useEmailViewProps();
  const uiModeProps = useEmailUIModeProps();
  useEffect(() => {
    Metrics.timer('framework-prerender').update(performance.now());
  }, []);
  return /*#__PURE__*/_jsx(FrameworkListingLibProvider, {
    fetcher: searchCrm,
    hiddenFilter: hiddenFilter,
    initialFilter: initialFilter,
    objectType: MARKETING_EMAIL_OBJECT_TYPE,
    propertyOverride: propertyOverride,
    searchInputProps: searchInputProps,
    trackerProps: trackerProps,
    uiModeProps: uiModeProps,
    viewProps: viewProps,
    children: children
  });
}